import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";

import colors from "../../assets/style/colors";

const styles = {
  menuItem: {
    height: "40px",
    paddingLeft: "16px",
    "&:hover": {
      backgroundColor: colors.lightGreenBg,
      color: colors.primary,
    },
  },
};

const MenuElement = (props) => {
  const { history, item, classes } = props;

  const handleClick = (e, url) => {
    if (!props.blockClick) {
      history.push(url);
      props.closeMenu(e);
    }
  };

  return (
    <MenuItem
      className={classes.menuItem}
      onClick={(e) => handleClick(e, `/${item}`)}
    >
      <ListItemText style={{ fontSize: "0.875em" }} disableTypography>
        {I18n.get(`topbar_${item}`)}
      </ListItemText>
    </MenuItem>
  );
};

export default withRouter(withStyles(styles)(MenuElement));
